import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import twitterText from 'twitter-text';
import { unescape } from 'lodash';
import { OLD_HOST_REDIRECTS, Hostname } from 'constants/hostnames';
import { filterEmptyValues, isObjectKey, isValueInObject } from './object';

const toUrlQuery = params => {
  const keys = Object.keys(params);
  return keys.map(key => {
    const value = params[key];

    if (Array.isArray(value)) {
      return value.map(item => "".concat(key, "[]=").concat(encodeURIComponent(item))).join('&');
    }

    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};

const toParams = urlQuery => {
  const searchParams = new URLSearchParams(urlQuery);
  const params = {};
  searchParams.forEach((value, key) => {
    const potentialArrayKeyMarker = key.substring(key.length - 2, key.length);

    if (potentialArrayKeyMarker === '[]') {
      const arrayKey = key.substring(0, key.length - 2);
      params[arrayKey] = params[arrayKey] || [];
      params[arrayKey].push(value);
      return;
    }

    params[key] = value;
  });
  return params;
};

const toNextjsParams = urlQuery => {
  const searchParams = new URLSearchParams(urlQuery);
  const params = {};
  searchParams.forEach((value, key) => {
    if (params[key]) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]];
      }

      params[key].push(value);
    } else {
      params[key] = value;
    }
  });
  return params;
};

const urlWithParams = (url, params) => {
  const [, path = '/', urlParams = '', urlHash = ''] = url.match(/^([^?#]+)(\?[^#]*)?(#.*)?$/) || [];
  const newParams = toUrlQuery(_objectSpread(_objectSpread({}, toParams(urlParams)), filterEmptyValues(params)));
  return "".concat(path).concat(newParams ? "?".concat(newParams) : '').concat(urlHash);
};

const convertUrls = (text, replacement) => {
  // @ts-ignore find a proper way to augment twiter-text module declaration
  const {
    extractUrl,
    urlHasProtocol
  } = twitterText.regexen;
  const doesBeginWithSpace = /^\s/;
  const doesBeginWithNewline = /(\r\n|\r|\n)/;
  let index = 0;
  const values = {};
  const formattedText = text.replace(extractUrl, url => {
    index += 1;
    const rawUrl = url.replace(/\s+/g, '');
    const urlWithProtocol = urlHasProtocol.test(rawUrl) ? rawUrl : "//".concat(rawUrl);
    const paramName = "link".concat(index);
    let prefix = '';

    if (doesBeginWithNewline.test(url)) {
      prefix = '\n';
    } else if (doesBeginWithSpace.test(url)) {
      prefix = ' ';
    }

    values[paramName] = replacement(urlWithProtocol, rawUrl);
    return "".concat(prefix, "{").concat(paramName, "}");
  });
  return {
    text: formattedText,
    values
  };
};

const isUrlRelative = urlToTest => new URL(document.baseURI).origin === new URL(urlToTest, document.baseURI).origin;

const isInternalHostname = host => isValueInObject(host, Hostname);

const normalizeHost = host => host.replace(/^www\./, '');

const linkifyString = text => {
  const URL_OR_ANCHOR_TAG_REGEX = /(<a[\s\S]*?>[\s\S]*?<\/a>)|(https?:\/\/(www\.)?[a-zA-Z0-9-]+\.[^<\s]+)/gi;
  const unescapedText = unescape(text);
  return unescapedText.replace(URL_OR_ANCHOR_TAG_REGEX, (match, anchor) => {
    if (anchor) return match;
    return "<a href=\"".concat(match, "\">").concat(match, "</a>");
  });
};

const normalizedQueryParam = param => [param].join();

const isCurrentUrl = (relativeUrl, pathname) => {
  return relativeUrl.includes(pathname);
};

const getLastPathnameParam = (relativeUrl, url) => {
  const splitRelativeUrl = (url || relativeUrl).split('/');
  return splitRelativeUrl[splitRelativeUrl.length - 1];
};

const getPathnameParam = (relativeUrl, index) => {
  const splitRelativeUrl = relativeUrl.split('/'); // splitRelativeUrl[0] is an empty string, hence returning index + 1
  // returning empty string for consistency sake when url has no params, e.g. vinted.com/

  return splitRelativeUrl[index + 1] || '';
};

const getOldHostRedirectUrl = host => {
  const normalizedHost = normalizeHost(host);
  if (!isObjectKey(normalizedHost, OLD_HOST_REDIRECTS)) return '';
  return "https://".concat(OLD_HOST_REDIRECTS[normalizedHost]);
};

const replaceUrlHost = (url, host) => {
  if (!host.match(/^https?:\/\//)) return url;
  return url.replace(/^(https?:\/\/[^/]+\/|\/)/, "".concat(host, "/"));
};

const removeParamsFromQuery = (relativeUrl, urlQuery, paramsToRemove) => {
  const urlParams = toParams(urlQuery);
  paramsToRemove.forEach(param => delete urlParams[param]);
  if (!Object.keys(urlParams).length) return relativeUrl;
  return "".concat(relativeUrl, "?").concat(toUrlQuery(urlParams));
};

const getReferrerPath = () => document.referrer ? new URL(document.referrer).pathname : 'unknown';

export { toUrlQuery, toParams, toNextjsParams, urlWithParams, convertUrls, linkifyString, isUrlRelative, isInternalHostname, normalizedQueryParam, isCurrentUrl, getLastPathnameParam, getPathnameParam, normalizeHost, getOldHostRedirectUrl, replaceUrlHost, removeParamsFromQuery, getReferrerPath };